import Vue from 'vue'
import Router from 'vue-router'

// 主路由
import Home from '@/components/Home'
import clientRoutes from '@/router/client/index'
import touristRoutes from '@/router/tourist/index'
import NotFound from '@/components/NotFound'

Vue.use(Router)

export default new Router({
  routes: [
    {path: '/not-found', component: NotFound},
    {
      path: '/',
      component: Home,
      children: [
        clientRoutes,
        touristRoutes
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js